import axios from "axios";
import { error_messages } from "../consts/messages";
import { appConfig } from "../enviroments/enviroment";
import {
  append_to_dom,
  catch_error,
  get_user_info,
} from "../firebase/functions";

var user_cookbooks = [];
var cookbook_name = "";
var is_cookbook_public = false;

var cookbook_delete_name = "";

jQuery(document).ready(function ($) {
  if (
    window.location.pathname == "/profile/my-cookbooks" ||
    window.location.pathname == "/profile/my-cookbooks/"
  ) {
    if (localStorage.getItem("user_info")) {
      if (JSON.parse(localStorage.getItem("user_info"))?.cookbooks) {
        if (
          JSON.parse(localStorage.getItem("user_info"))?.cookbooks.length != 0
        ) {
          user_cookbooks = JSON.parse(
            localStorage.getItem("user_info")
          )?.cookbooks;
          render_my_cookbooks();
        } else {
          render_is_empty();
        }
      } else {
        render_is_empty();
      }
    }
  }

  if (user_cookbooks.length == 0 && !$(".section--public--coockbooks")) {
    $("#new_cookbook_box").addClass("is-form-open");
    $("#new_cookbook_submit_container").css("display", "flex");
    render_is_empty();
  }

  $("#new_cookbook_box").on("click", function () {
    if (localStorage.getItem("login_result")) {
      if (JSON.parse(localStorage.getItem("login_result")).is_logged_in) {
        $(this).addClass("is-form-open");
        $("#new_cookbook_submit_container").css("display", "flex");
      } else {
        append_to_dom("popup-login-open", "popup-login", handle_after_login);
        localStorage.setItem("cookbook_box_should_open", true);
      }
    } else {
      append_to_dom("popup-login-open", "popup-login");
      localStorage.setItem("cookbook_box_should_open", true);
    }
  });

  $("#new_cookbook_cancel").on("click", function () {
    clear_fields();
  });

  // Detect input changes
  $("#box-field").on("change input focus", function (e) {
    cookbook_name = e.target.value;
    if (e.target.value === "" || e.target.value.trim().length === 0) {
      $("#new_cookbook_submit").prop("disabled", true);
    } else {
      $("#new_cookbook_submit").prop("disabled", false);
    }
  });

  $("#list-radios input").on("change", function (e) {
    if (e.target.attributes["data-is-public"].value == "true") {
      is_cookbook_public = true;
    } else {
      is_cookbook_public = false;
    }
  });

  $("#new_cookbook_form").submit("submit", function (e) {
    e.preventDefault();
    create_cookbook();
  });

  function create_cookbook() {
    $("#new_cookbook_submit").addClass("button--loading");
    const url = `${appConfig.API.URL}/cookbook`;
    let body = {
      action: "create",
      categoryName: cookbook_name,
      isPublic: is_cookbook_public,
    };

    axios
      .post(url, body, {
        headers: {
          "x-api-key": appConfig.API.KEY,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })

      .then(() => {
        get_user_info(false, true, true);
      })
      .then(() => {
        if ($("#no_user_cookbooks")) {
          $("#no_user_cookbooks").remove();
        }
      })
      .then(() => {
        clear_fields();
      })
      .catch((err) => {
        catch_error(err);
        if (err) {
          if (err.response) {
            if (err.response.status) {
              if (err.response.status == 403) {
                $("#cookbook_error").text(error_messages.cookbook_exists);
              }
            }
          }
        }
        $("#new_cookbook_submit").removeClass("button--loading");
      });
  }

  function clear_fields() {
    $("#new_cookbook_box").removeClass("is-form-open");
    $("#new_cookbook_submit_container").css("display", "none");
    $(".new_cookbook_box ").removeClass("is-form-open");
    $(".cookbook_submit_container").css("display", "none");

    $("#box-field").val("");
    $("#list-radios #public-cookbook")
      .attr("checked", false)
      .prop("checked", false);
    $("#list-radios #private-cookbook")
      .attr("checked", true)
      .prop("checked", true);

    $("#new_cookbook_submit").prop("disabled", true);

    $("#new_cookbook_submit").removeClass("button--loading");
    $("#cookbook_error").text("");
    cookbook_name = "";
  }

  function render_is_empty() {
    $("#user_cookbooks_container").append(
      `<h2 id="no_user_cookbooks">لا كتب طبخ</h2>`
    );
  }

  $("#delete_my_cookbook_page").on("click", function () {
    cookbook_delete_name = $("#cookbook_name").text();
    append_to_dom(
      "popup-delete-my-cookbook-open",
      "delete_my_cookbook_confirm",
      null
    );
  });

  $(document).on(
    "click",
    "#delete_my_cookbook_confirm #recipe_delete_cancel",
    function () {
      $("#delete_my_cookbook_confirm").remove();
      cookbook_delete_name = "";
    }
  );

  $(document).on(
    "click",
    "#delete_my_cookbook_confirm #recipe_delete_confirm",
    function () {
      $("#delete_my_cookbook_confirm #recipe_delete_confirm").addClass(
        "button--loading"
      );

      const url = `${appConfig.API.URL}/cookbook`;
      let body = {
        action: "delete",
        categoryName: cookbook_delete_name,
      };

      axios
        .post(url, body, {
          headers: {
            "x-api-key": appConfig.API.KEY,
            contentType: "application/json; charset=utf-8",
            Authorization: ` Bearer ${
              JSON.parse(localStorage.getItem("login_result"))?.access_token
            }`,
          },
        })

        .then(() => {
          get_user_info(false, false, true, true, "/profile/my-cookbooks");
        })
        .then(() => {
          $("#delete_my_cookbook_confirm #recipe_delete_confirm").removeClass(
            "button--loading"
          );
          $("#delete_my_cookbook_confirm").remove();
          cookbook_delete_name = "";
        })
        // .then(() => {
        //   window.location.href = "/cookbooks";
        // })

        .catch((err) => {
          catch_error(err);
          $("#delete_my_cookbook_confirm #recipe_delete_confirm").removeClass(
            "button--loading"
          );
        });
    }
  );
});

export function render_my_cookbooks() {
  let my_cookbooks = JSON.parse(localStorage.getItem("user_info"))?.cookbooks;
  let data = `&action=load_my_cookbooks&user_cookbooks=${JSON.stringify(
    my_cookbooks
  )}`;
  $.ajax({
    type: "POST",
    dataType: "html",
    url: load_my_cookbooks.ajaxurl,
    data: data,
    success: function (res) {
      $("#user_cookbooks_container .grid").remove();
      $("#user_cookbooks_container").append('<div class="grid"></div>');
      $("#user_cookbooks_container .grid").append(res);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(jqXHR);
      console.log(textStatus);
      console.log(errorThrown);
    },
  });
}
export function handle_cookbook_box_after_login() {
  $("#new_cookbook_box").addClass("is-form-open");
  $("#new_cookbook_submit_container").css("display", "flex");
}
